import React from 'react';
import './cardHira.scss';
import logo from "../../../assets/imgs/logo-removebg.png"
import { Link } from 'react-router-dom';
import { baseUrl } from '../../../config/config';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';

const CardHira = ({hiras, handleDelete}) => {

  return (
    <div className="cardHira">
      <img src={logo} alt="logo" />
      <p className='lohateny'>{hiras.lohateny}</p>
      <p className='vavaka'>{hiras?.tonony}</p>
      <div className="audio-container">
        {hiras.audio && (
          <div className="audio-container">
            <audio controls className="audio">
              <source src={`${baseUrl}/hira/stream-audio/${hiras.id}`} type="audio/mp3" />
            </audio>
          </div>
        )}
      </div>

      <div className='buttonContainer' >
        <Link to={`/hira/updateHira/${hiras.id}`}>
          <button><FaEdit /></button>
        </Link>

        <button className='btn' onClick={handleDelete}><MdDelete /></button>
      </div>
    </div>
  )
}

export default CardHira;